"use strict";

exports.__esModule = true;
exports.PermissionsError = exports.CheckAccessRoute = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _Access = require("../../Auth/Access");
var _UhOh = require("../UhOh");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var PermissionsError = exports.PermissionsError = /*#__PURE__*/_react["default"].createElement(_UhOh.UhOh, {
  error: new Error("You do not have permission to view this page")
});
function createHistoryShim(navigate, location) {
  return {
    length: typeof window !== "undefined" ? window.history.length : 0,
    action: "PUSH",
    location: location,
    push: function push(to, state) {
      if (typeof to === "number") {
        navigate(to);
        return;
      }
      navigate(to, {
        state: state,
        replace: false
      });
    },
    replace: function replace(to, state) {
      navigate(to, {
        state: state,
        replace: true
      });
    },
    go: function go(n) {
      navigate(n);
    },
    goBack: function goBack() {
      navigate(-1);
    },
    goForward: function goForward() {
      navigate(1);
    },
    canGo: function canGo() {
      return true;
    },
    block: function block() {
      return function () {};
    },
    listen: function listen() {
      return function () {};
    },
    createHref: function createHref(to) {
      if (typeof to === "string") return to;
      var _ref = to || {},
        _ref$pathname = _ref.pathname,
        pathname = _ref$pathname === void 0 ? "" : _ref$pathname,
        _ref$search = _ref.search,
        search = _ref$search === void 0 ? "" : _ref$search,
        _ref$hash = _ref.hash,
        hash = _ref$hash === void 0 ? "" : _ref$hash;
      return "" + pathname + search + hash;
    }
  };
}

/**
 * Access-gated route content for RR6.
 * Use as: <Route path={...} element={<CheckAccessRoute permission=... component=... />} />
 * (Must not wrap <Route> — RR6 only allows Route/Fragment as Routes children.)
 */
var CheckAccessRoute = exports.CheckAccessRoute = function CheckAccessRoute(_ref2) {
  var permission = _ref2.permission,
    featureFlag = _ref2.featureFlag,
    element = _ref2.element,
    Component = _ref2.component,
    render = _ref2.render,
    children = _ref2.children;
  var location = (0, _reactRouterDom.useLocation)();
  var navigate = (0, _reactRouterDom.useNavigate)();
  var params = (0, _reactRouterDom.useParams)();
  var history = (0, _react.useMemo)(function () {
    return createHistoryShim(navigate, location);
  }, [navigate, location]);
  var match = (0, _react.useMemo)(function () {
    return {
      params: params || {},
      path: location.pathname,
      url: location.pathname,
      isExact: true
    };
  }, [params, location.pathname]);
  var routeProps = {
    history: history,
    location: location,
    match: match,
    navigate: navigate
  };
  var content = null;
  if (element != null) {
    // Give an `element` the same v5-style route props the component/render
    // branches receive: screens rendered this way (UpdateReportScreenWithParams,
    // ReportScreenWithParams) still call this.props.history.push(). Host elements
    // are left alone — cloning route props onto a <div> leaks them to the DOM.
    content = /*#__PURE__*/_react["default"].isValidElement(element) && typeof element.type !== "string" ? /*#__PURE__*/_react["default"].cloneElement(element, routeProps) : element;
  } else if (Component) {
    content = /*#__PURE__*/_react["default"].createElement(Component, routeProps);
  } else if (render) {
    content = render(routeProps);
  } else if (children) {
    content = typeof children === "function" ? children(routeProps) : children;
  }
  return /*#__PURE__*/_react["default"].createElement(_Access.AccessCheck, {
    permission: permission,
    featureFlag: featureFlag
  }, function (_ref3) {
    var isAllowed = _ref3.isAllowed;
    if (isAllowed) {
      return content;
    }
    return PermissionsError;
  });
};